export default "{{STORE_NAME}} - Shortage Re-dispute - {{CURRENT_MONTH}} {{CURRENT_YEAR}} - {{CHILD_INVOICE_NUMBER}}\n"